import { UAE_WHATSAPP_LINK, UAE_WHATSAPP_NUMBER } from '../utils/uaeLocale';

const WhatsAppFloat = () => (
  <a
    href={UAE_WHATSAPP_LINK}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`WhatsApp support ${UAE_WHATSAPP_NUMBER}`}
    title={`WhatsApp · ${UAE_WHATSAPP_NUMBER}`}
    data-testid="uae-whatsapp-float"
    className="fixed z-50 flex items-center justify-center w-[56px] h-[56px] rounded-full bg-[#25D366] shadow-[0_8px_24px_rgba(37,211,102,0.45)] hover:scale-105 hover:shadow-[0_10px_28px_rgba(37,211,102,0.55)] transition-transform duration-200"
    style={{ right: '40px', bottom: 'calc(40px + env(safe-area-inset-bottom, 0px))' }}
  >
    <svg viewBox="0 0 32 32" className="w-8 h-8 fill-white" aria-hidden="true">
      <path d="M16.04 3C9.02 3 3.32 8.7 3.32 15.72c0 2.24.59 4.43 1.71 6.36L3.2 28.8l6.89-1.8a12.66 12.66 0 0 0 5.95 1.51h.01c7.01 0 12.72-5.7 12.72-12.72 0-3.4-1.32-6.59-3.72-8.99A12.63 12.63 0 0 0 16.04 3zm0 23.36h-.01a10.5 10.5 0 0 1-5.36-1.47l-.38-.23-3.98 1.04 1.06-3.88-.25-.4a10.55 10.55 0 0 1-1.62-5.7c0-5.83 4.74-10.57 10.58-10.57 2.82 0 5.48 1.1 7.47 3.1a10.5 10.5 0 0 1 3.1 7.48c0 5.83-4.75 10.57-10.57 10.57zm5.8-7.92c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.72.16-.21.32-.82 1.03-1 1.24-.19.21-.37.24-.69.08-.32-.16-1.34-.5-2.56-1.58-.95-.85-1.58-1.89-1.77-2.21-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.72-1.72-.98-2.36-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.65 0 1.56 1.14 3.07 1.3 3.28.16.21 2.25 3.44 5.45 4.82.76.33 1.36.53 1.82.67.77.25 1.46.21 2.01.13.61-.09 1.88-.77 2.14-1.51.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37z" />
    </svg>
  </a>
);

export default WhatsAppFloat;
